import type { BorderRadiusSettings } from './index';
import type { CssVars } from '../../css-vars';

import type { Corner, Device } from '../../utils';
import { CORNERS, DEVICE_SUFFIX, atDevice } from '../../utils';
import { cornerVar } from '../../mixins';

/** The short corner names the variables are spelled with. */
const CORNER_SUFFIX: Record<Corner, string> = {
    topLeft: 'tl',
    topRight: 'tr',
    bottomRight: 'br',
    bottomLeft: 'bl',
};

export function borderRadiusCornerVar(
    radius: BorderRadiusSettings | undefined,
    corner: Corner,
    device: Device = 'desktop'
): string {
    return cornerVar(atDevice(radius?.corners, device), corner);
}

/** `--<prefix>-radius-<tl|tr|br|bl>[-tablet|-mobile]` for the four corners. */
export function borderRadiusVars(
    radius: BorderRadiusSettings | undefined,
    prefix: string,
    device: Device = 'desktop'
): CssVars {
    return Object.fromEntries(
        CORNERS.map((corner) => [
            `--${prefix}-radius-${CORNER_SUFFIX[corner]}${DEVICE_SUFFIX[device]}`,
            borderRadiusCornerVar(radius, corner, device),
        ])
    );
}
